import {getRefinementCutOffThreshold} from '../../../../../../helper';
import colorRefinementOption from './color-refinement-option';
import showMoreSection from './show-more-section';

/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} color refinement HTML
 */
export default (refinement, refinementURLBuilder, seoUrlConfig) => {
    if (!refinement || !refinement.options) {
        return '';
    }
    const cutOffThreshold = getRefinementCutOffThreshold(refinement.baseID);
    const visibleRefinementItems = [];
    const cutOffRefinements = [];
    for (let i = 0, len = refinement.options.length; i < len; i++) {
        const option = refinement.options[i];
        const refinementHTML = colorRefinementOption(refinement, option, refinementURLBuilder, seoUrlConfig);
        if (i < cutOffThreshold) {
            visibleRefinementItems.push(refinementHTML);
        } else {
            cutOffRefinements.push(refinementHTML);
        }
    }
    let showMoreSectionHTML = '';
    if (cutOffRefinements.length > 0) {
        showMoreSectionHTML = showMoreSection(refinement, cutOffRefinements);
    }

    return `
        <ul class="swatches color ${refinement.id}">
            ${visibleRefinementItems.join('')}
            ${showMoreSectionHTML}
        </ul>
    `;
};
